/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import { useEffect, useState } from "react";

import * as THREE from "three";
import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { GLTF } from "three-stdlib";
// Mui imports
import { useMediaQuery } from "@mui/material";
type GLTFResult = GLTF & {
  nodes: {
    Circle001: THREE.Mesh;
    Torus: THREE.Mesh;
    Path_1: THREE.Mesh;
  };
  materials: {
    ["Material.001"]: THREE.MeshStandardMaterial;
    Material: THREE.MeshStandardMaterial;
    ["SVGMat.001"]: THREE.MeshStandardMaterial;
  };
};

export function InfoOutlineModel(props: any) {
  //@ts-ignore
  const { nodes, materials } = useGLTF("/info_outline.glb") as GLTFResult;
  const matches = useMediaQuery("(min-width:600px)");

  const [hover, setHover] = useState(false);

  const ref: any = useRef();

  useEffect(() => {
    if (ref.current) {
      ref.current.lookAt(0, 0, 0);
    }
  }, [ref.current]);

  useEffect(() => {
    document.body.style.cursor = hover ? "pointer" : "grab";
  }, [hover]);

  return (
    <group
      ref={ref}
      {...props}
      dispose={null}
      onPointerOver={() => setHover(true)}
      onPointerOut={() => setHover(false)}
      onClick={() => props.onClick()}
    >
      {matches ? (
        <></>
      ) : (
        <mesh
          geometry={new THREE.SphereGeometry(8, 16, 8)}
          material={
            new THREE.MeshBasicMaterial({
              // color: 0xaaaaaa,
              // wireframe: true,
              visible: false,
            })
          }
          position={[0, 0, 0]}
          scale={1}
        />
      )}
      <mesh
        geometry={nodes.Circle001.geometry}
        material={
          new THREE.MeshBasicMaterial({
            color: 0xf26920,
            opacity: 0.5,
            transparent: true,
          })
        }
        position={[0, -0.1, -0.1]}
        rotation={[Math.PI / 2, 0, 0]}
      />
      {hover && (
        <mesh
          geometry={nodes.Torus.geometry}
          material={materials.Material}
          position={[0, 0, -0.1]}
          rotation={[Math.PI / 2, 0, 0]}
          scale={[2.09, 0.47, 2.09]}
        />
      )}
      <mesh
        geometry={nodes.Path_1.geometry}
        material={materials["SVGMat.001"]}
        position={[0, 0.11, -0.11]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={263.31}
      />
    </group>
  );
}

useGLTF.preload("/info_outline.glb");
